const useIsReactNativeWebView = (): { isRnWebView: boolean } =>
  // isRnWebView comes from injected javascript from react native app
  ({ isRnWebView: typeof window !== undefined ? Boolean(window.isRnWebView) : false });
export default useIsReactNativeWebView;
